import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const addNewVehicle = createAsyncThunk(
    'vehicleInvoiceSlice/addNewVehicle',
    async (vehicleData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();

            formData.append("name", vehicleData.name);
            formData.append("description", vehicleData.description);
            formData.append("chassis_no", vehicleData.chassisNo);
            formData.append("mileage", vehicleData.mileage);
            formData.append("engine_capacity", vehicleData.engineCapacity);
            formData.append("reg_year", vehicleData.regYear);
            formData.append("mfg_year", vehicleData.mfgYear);
            formData.append("makeId", vehicleData.makeId);
            formData.append("modelId", vehicleData.modelId);
            formData.append("countryId", vehicleData.countryId);
            formData.append("vehicleTypeId", vehicleData.vehicleTypeId);
            formData.append("thumbnail", vehicleData.thumbnail);
       
            const response = await axios.post(`${PUBLIC_BASE_URL}/vehicle/create-vehicle-for-invoices`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editInvoiceVehicle = createAsyncThunk(
    'vehicleInvoiceSlice/editInvoiceVehicle',
    async (updatedData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
       
            const response = await axios.post(`${PUBLIC_BASE_URL}/vehicle-for-invoices/update-vehicle-for-invoice`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);